import React from "react";
import image from "assests/contact/1.png";
import image_ar from "assests/contact/1-ar.png";
import Container from "Components/Container/Container";
import { MapPin, Phone, Envelope } from "@phosphor-icons/react";
import line from "assests/contact/2.png";
import line_ar from "assests/contact/2-ar.png";
import { useTranslation } from "react-i18next";

const ContactHero = ({ data }) => {
  const { t, i18n } = useTranslation();
  return (
    <section className="bg-black pt-[18vh] pb-primary">
      <Container>
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="lg:flex-[3] flex flex-col gap-y-3 text-white">
            <h1 className="text-4xl text-secondary titles-font ">
              {t("contact_info")}
            </h1>
            <p className="mb-4">{t("Address")}</p>

            <div className="flex flex-col gap-y-4">
              <div className="flex items-center gap-x-2">
                <span className="bg-secondary p-1 text-lg text-black rounded-full">
                  <Phone />
                </span>
                <a
                  href={`tel:${
                    i18n.language === "ar" ? "+966598670797" : "+966598670797"
                  }`}
                  dir="ltr"
                  className="text-white hover:underline"
                >
                  <p dir="ltr" className="text-lg">
                    {i18n.language === "ar"
                      ? "+966 5986 70797"
                      : "+966 5986 70797"}
                  </p>
                </a>
              </div>
              <div className="flex items-center gap-x-2">
                <span className="bg-secondary p-1 text-lg text-black rounded-full">
                  <Envelope />
                </span>
                <a
                  href={`mailto:${data?.email}`}
                  className="text-white"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {data?.email}
                </a>
              </div>
              <div className="flex items-center gap-x-2">
                <span className=" text-3xl text-secondary rounded-full">
                  <MapPin />
                </span>
                <a
                  href={data?.location_url}
                  className="text-white underline capitalize"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("View_location_map")}
                </a>
              </div>
            </div>
          </div>
          <div className="lg:flex-[2.2] relative">
            <img src={i18n.language === "ar" ? image_ar : image} alt="" />

            <div className="absolute right-0 top-16 hidden xl:block">
              <img
                className="object-contain"
                src={i18n.language === "ar" ? line_ar : line}
                alt=""
              />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ContactHero;
